import { Lesson } from "./types";

export default function getWatch(lesson: Lesson) {
  if (!lesson || !lesson.sections) {
    return null;
  }

  const watch = lesson.sections.find((section) => /watch/i.test(section.title));

  if (!watch) {
    return null;
  }

  return watch.slides;
}
